import { api_host } from "../../common/globals/constants";

/**
 * 
 * @param {number} objective 
 * @param {number} node 
 * @param {string} token 
 * @param {string} date 
 * @param {number} user 
 * @returns {Promise<Object>} - Retorna un objeto JSON con los registros plus del objetivo especificado.
 * @description Obtiene los registros plus de un objetivo específico, filtrando por nodo, fecha y usuario.
 */
export async function getRegistersPlusByObjective(
    objective,
    node,
    token,
    date,
    user
) {
    return await fetch(
        `${api_host}/reporte/general/objetivos/${objective}/registro_plus/?token=${token}&t=h&node=${node}&date=${date}&user=${user}`
    );
}
